/** Current API role value for dockhands (legacy stored/read value: Captain). */
export const DOCKHAND_ROLE = 'Dockhand';

export const LEGACY_CAPTAIN_ROLE = 'Captain';

export function isDockhandRole(role: string | null | undefined): boolean {
  const normalized = (role ?? '').trim().toLowerCase();
  return normalized === 'dockhand' || normalized === 'captain';
}

/** User-facing label for authorized-user / portal roles. */
export function formatAuthorizedUserRole(role: string | null | undefined): string {
  if (isDockhandRole(role)) {
    return 'Dockhand';
  }
  if (!role) {
    return '';
  }
  return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
}

/** Normalize form/API payload to Dockhand for assignable dockhand role. */
export function normalizeDockhandRoleValue(role: string | null | undefined): typeof DOCKHAND_ROLE | string {
  return isDockhandRole(role) ? DOCKHAND_ROLE : (role ?? '');
}
